<template>
  <v-container>
    <v-row justify="center" wrap>
      <plan-card
          v-for="plan in plans"
          :plan="plan"
          :key="plan.hash"
          class="mx-md-2 mx-1"
      />
      <contact-plan-card class="mx-md-2 mx-1" />
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-card-subtitle class="assistant text-center subtitleStyle">
          <p>
            תוקף המנוי לשנה אחת בלבד<br />לפרטים נוספים לחצו
            <a
                href="https://drive.google.com/file/d/1JDKjTXRbhuYNfgA6a_5m8VDBxa9R2BvJ/view?usp=sharing"
                target="_blank"
            >כאן</a
            >
          </p>
          <p>רוצים להכיר את ClapLab?
            <a href="https://site.clap-lab.com/" target="_blank">לחצו כאן להדרכות</a>
          </p>
          <p>
            לתמיכה ואפשרויות פרמיום צרו איתנו קשר
            <a href="mailto:games@closeapp.co.il">games@closeapp.co.il</a>
          </p>
        </v-card-subtitle>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { types } from "../../store/modules/Plan.module";
import PlanCard from "./PlanCard";
import ContactPlanCard from "./ContactPlanCard";

export default {
  name: "PlansView",
  components: { PlanCard, ContactPlanCard },
  computed: {
    plans() {
      let plans = [...this.$store.state.PlanModule.plans];
      if (this.hideFree) {
        plans = plans.filter((plan) => plan.price !== 0);
      }
      return plans.sort(
          (a, b) => a.price - b.price
      );
    },
    hideFree() {
      //hf stands for 'hide plan'
      return this.$route.query.hf === "t";
    },
    freeLink() {
      return `/payment/free/${this.freePlan.hash}`;
    },
    freePlan() {
      return this.$store.state.PlanModule.plans.find(plan => plan.price === 0);
    },
    additional() {
      return JSON.parse(this.freePlan.additional || "{}");
    }
  },
  async created() {
    await this.$store.dispatch(types.FETCH);
  }
};
</script>

<style>
.titleStyle {
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 112.8%;
  /* or 73px */
  text-align: center;

  color: #db482d;
}

.subtitleStyle {
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 112.8%;
  /* or 25px */
  text-align: center;

  color: #374d8f;
}

#yellowBtn {
  background: url("../../../public/img/btn_background.png");
  color: #374d8f;
  width: 183px;
  height: 30px;
  border-radius: 28px;
}

.cardStyle {
  border-radius: 20px;
  width: 280px;
  min-height: 377px;
}

.innerCardStyle {
  background-color: #e8e8e8;
  text-align: center;
  margin: 6px;
}

.innerCardTitle {
  background-color: #db482d;
  padding: 6px;
}

.textColor {
  color: #374d8f;
}

.badge-overlay {
  position: absolute;
  left: 0%;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 100;
  -webkit-transition: width 1s ease, height 1s ease;
  -moz-transition: width 1s ease, height 1s ease;
  -o-transition: width 1s ease, height 1s ease;
  transition: width 0.4s ease, height 0.4s ease;
}

.badge {
  margin: 0;
  color: white;
  padding: 4px 4px;
  font-size: 20px;
  font-family: Arial, Helvetica, sans-serif;
  text-align: center;
  line-height: normal;
  text-transform: uppercase;
  background: #374d8f;
}

.badge::before,
.badge::after {
  content: "";
  position: absolute;
  top: 0;
  margin: 0 -1px;
  width: 100%;
  height: 100%;
  background: inherit;
  min-width: 55px;
}

.badge::before {
  right: 100%;
}

.badge::after {
  left: 100%;
}

.top-right {
  position: absolute;
  top: 0;
  right: 0;
  -ms-transform: translateX(30%) translateY(0%) rotate(45deg);
  -webkit-transform: translateX(30%) translateY(0%) rotate(45deg);
  transform: translateX(30%) translateY(0%) rotate(45deg);
  -ms-transform-origin: top left;
  -webkit-transform-origin: top left;
  transform-origin: top left;
}
</style>
